import { apiFetch } from './client';
import type { Task, Ticket, TicketComment } from '$lib/types';

export const ticketsApi = {
  // Admin-only inbox (unassigned, project_id NULL). Members never see this.
  inbox: () => apiFetch<{ results: Ticket[]; count: number }>('/tickets?inbox=1'),
  forProject: (projectId: number) =>
    apiFetch<{ results: Ticket[]; count: number }>(`/projects/${projectId}/tickets`),
  get: (id: number) => apiFetch<Ticket>(`/tickets/${id}`),
  update: (id: number, body: { status?: string; assignee_user_id?: number | null; deploy_sha?: string }) =>
    apiFetch<Ticket>(`/tickets/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  // Admin-only triage: sets project_id, status stays "open", server
  // auto-assigns the first member granted to that project.
  assign: (id: number, projectId: number) =>
    apiFetch<Ticket>(`/tickets/${id}/assign`, {
      method: 'POST',
      body: JSON.stringify({ project_id: projectId })
    }),
  comments: (id: number) => apiFetch<{ results: TicketComment[] }>(`/tickets/${id}/comments`),
  addComment: (id: number, body: string) =>
    apiFetch<TicketComment>(`/tickets/${id}/comments`, { method: 'POST', body: JSON.stringify({ body }) }),
  // Create a linked task from this ticket — returns the full created Task
  // (201, taskJSON — NOT a bare {task_id}, despite the api spec's summary
  // wording; verified against internal/api/handlers/tickets.go).
  createTask: (id: number) => apiFetch<Task>(`/tickets/${id}/task`, { method: 'POST' })
};
